/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import * as z from "zod";
import { getJsonValidator } from "./getJsonValidator";
import { getStringValidator } from "./getStringValidator";
import { getNumberValidator } from "./getNumberValidator";

export const getSchema = (setting: any) => {
  if (!setting) return z.string();

  const normalizedType = setting.type === "bool" ? "boolean" : setting.type;

  if (normalizedType === "json") {
    return getJsonValidator(setting.rules ?? []);
  } else if (
    normalizedType === "string" ||
    normalizedType === "secret" ||
    normalizedType === "select" ||
    normalizedType === "url" ||
    normalizedType === "boolean"
  ) {
    return getStringValidator(setting.rules ?? []);
  } else if (normalizedType === "number") {
    return getNumberValidator(setting.rules ?? []);
  }
  return z.string();
};
